import { privacyConstants } from '../../constants'

const initialState = {
  trmsCn: {},
  isLoading: false,
  isFailure: false,
}

// reducer 는 현재 상태와 액션 객체를 파라미터로 받아와서 새로운 상태를 반환해주는 함수입니다.
export default function privacy(state = initialState, action) {
  switch (action.type) {
    /**
     * 리스트
     */
    case privacyConstants.LOAD_REQUEST:
      return {
        ...state,
        isLoading: !state.isLoading,
      }
    case privacyConstants.LOAD_SUCCESS:
      return {
        ...state,
        data: action.response.data.payload,
      }
    case privacyConstants.LOAD_FAILURE:
      return {
        isLoading: false,
        isFailure: true,
      }

    default:
      return state
  }
}
